import { render, staticRenderFns } from "./FormBox.vue?vue&type=template&id=45f51a03&scoped=true&"
import script from "./FormBox.vue?vue&type=script&lang=js&"
export * from "./FormBox.vue?vue&type=script&lang=js&"
import style0 from "./FormBox.vue?vue&type=style&index=0&id=45f51a03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f51a03",
  null
  
)

export default component.exports